export const indiaGoldenTriangleProgram = {
  programKey: 'indie-od-zlotego-trojkata-po-ganges',

  /* Podstawowe informacje wspólne dla sticky paska i przyszłego katalogu. */
  title: 'Indie: Od Złotego Trójkąta po Ganges',

  /* Dwuczęściowa nazwa wyświetlana w sticky pasku na PC i tablecie. */
  stickyTitle: 'Indie:',
  stickySubtitle: 'Od Złotego Trójkąta po Ganges',

  pageUrl:
    'https://coolturystki.pl/wycieczki/indie-od-zlotego-trojkata-po-ganges',

  /* Dane marketingowe będzie można uzupełnić podczas pracy nad katalogiem. */
  catalog: {
    image:
      'https://coolturystki.pl/lib/wyfaqa/indie-taj-mahal-agra-wschod-slonca-msyam1jd.webp',
    heroImageFallback:
      'https://coolturystki.pl/lib/wyfaqa/indie-taj-mahal-agra-wschod-slonca-msyam1jd.webp',
    imagePosition: 'center center',
    summary: '',
    destinations: ['Indie'],
    categories: [],
    travelStyles: ['Wyjazd objazdowy', 'Egzotyka'],
    catalogPublishedAt: '2026-08-19',
  },

  /* Każdy termin jest osobnym wyjazdem w Vakanzie. */
  tripIds: [6, 10],

  /*
   * Nie dodajemy priceNote ani priceNotePrice. Dzięki temu pod kartą
   * automatycznie pojawi się pierwsza transza wyliczona z aktualnej ceny.
   */
  termDetails: {
    '6': {
      pilotId: 'pawel',
      group: 'Dla kobiet i mężczyzn',
      airport: 'Warszawa - Chopina',

      expandedDetails: {
        flight: {
          title: 'Wylot grupowy z Warszawy',
          description:
            'Grupa leci z Lotniska Chopina w Warszawie (WAW) do New Delhi. Możliwe jest też rozpoczęcie podróży w Krakowie, Gdańsku, Poznaniu lub Wrocławiu i dołączenie do grupy podczas przesiadki w Warszawie.',
        },
        hotel: {
          title: 'Hotele 3★ i 4★ na trasie objazdu',
          description:
            'Noclegi w New Delhi, Jaipurze, Agrze, Ranthambore i Varanasi. Przewidziane są hotele 3★ i 4★, pokoje 2-osobowe oraz śniadania hotelowe.',
        },
      },
    },

    '10': {
      pilotId: 'pawel',
      group: 'Dla kobiet i mężczyzn',
      airport: 'Warszawa - Chopina',

      expandedDetails: {
        flight: {
          title: 'Wylot grupowy z Warszawy',
          description:
            'Grupa leci z Lotniska Chopina w Warszawie (WAW) do New Delhi. Możliwe jest też rozpoczęcie podróży w Krakowie, Gdańsku, Poznaniu lub Wrocławiu i dołączenie do grupy podczas przesiadki w Warszawie.',
        },
        hotel: {
          title: 'Hotele 3★ i 4★ na trasie objazdu',
          description:
            'Noclegi w New Delhi, Jaipurze, Agrze, Ranthambore i Varanasi. Przewidziane są hotele 3★ i 4★, pokoje 2-osobowe oraz śniadania hotelowe.',
        },
      },
    },
  },
}
